import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { GaEventService } from '@analytics/services/ga.event.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { FormStep } from '@dgx-pr-spa/shared/util';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProductDetailsService } from '@product-details/services/product-details.service';
import * as fromSelected from '@product-details/store/actions/selected.action';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { switchMap, tap } from 'rxjs/operators';

@Injectable()
export class SelectedEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly router: Router,
    private readonly viewOffersService: ViewOffersService,
    private readonly gaEventService: GaEventService,
    private readonly completeOrderService: CompleteOrderService,
    private readonly productDetailsService: ProductDetailsService,
    private readonly additionalServicesService: AdditionalServicesService
  ) {}

  selectedOffers$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromSelected.selectOffer),
        switchMap(() => this.viewOffersService.offerReference$),
        tap((PRRef) => {
          this.additionalServicesService.loadItemOffer();
          this.additionalServicesService.resetExtras();
          this.additionalServicesService.resetProtection();
          this.additionalServicesService.resetDeclineProtection();
          this.additionalServicesService.resetTermsConditions();
          this.productDetailsService.resetDeliveryDates();
          this.productDetailsService.loadDeliveryDates();
          this.completeOrderService.resetOrderForm();
          this.completeOrderService.resetDirectDebitValidation();
          this.completeOrderService.resetDirectDebitAttempts();
          this.completeOrderService.resetDirectDebitConfig();
          this.completeOrderService.updateActiveFormStep(FormStep.Delivery);
          this.gaEventService.ProductDetailsPageLoad();
          this.router.navigate(['/product-details'], {
            queryParams: { PRRef },
          });
        })
      ),
    { dispatch: false }
  );
}
